
// TBD: needs to be updated with AssetLoader in mind

import { getPropertyByKeyPath } from "./properties.js";
import { objects } from "../utils/objects.js";
import { createSingletonLogger } from "./singleton-logger.js";

class Store {
  // Component identity for logging
  static componentName = "store";
  
  #logger;
  cache = {};
  
  constructor() {
    // Initialize the singleton logger
    this.#logger = createSingletonLogger(this);
  }

  get(path, options = {}) {
    const value = objects.get(this.cache, path);
    if (options.logError && value === undefined) {
      this.#logger.error(`Unable to find property ${path} in the store`);
    }

    // it makes sense to create only copies of objects, because they
    // are passed by reference. It must not copy functions, because
    // functions can't be stringified
    if (typeof value === "object") {
      return objects.clone(value);
    }

    return value;
  }

  set(path, value, force) {
    const currentValue = objects.get(this.cache, path);
    if (currentValue === undefined || force) {
      objects.set(this.cache, path, value);
    }
  }

  remove(identifier) {
    const parts = identifier.split(".");
    const path = parts.slice(0, -1);
    const key = parts.at(-1);
    const parent = getPropertyByKeyPath(path, this.cache);
    return delete parent[key];
  }
}

const store = new Store();
export { Store, store };